
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'editSecretQuestion'
}

export const createSchema = (t: TFunction) => {
  // Regexp for secret answer
  // Can not include special characters
  // Must be between 1 and 35 characters long
  const regex = /(^[a-zA-Z0-9 ]{1,35}$)/
  return z.object({
    question: z.string().min(1, t('validation.question.required', tConfig)),
    answer: z.string()
      .min(1, t('validation.answer.required', tConfig))
      .max(35, t('validation.answer.length', tConfig))
      .regex(regex, t('validation.answer.pattern', tConfig))
      .refine((arg) => arg.trim().length > 0, t('validation.answer.required', tConfig))
  })
}

export type EditSecretQuestionFormData = z.infer<ReturnType<typeof createSchema>>
